export const saveRedactionCodeQuery = `
mutation saveRedactionCodeQuery($id: ID!, $schemaId: ID!, $data: JSONData!) {
  createStructuredData(input: {
    id: $id,
    schemaId: $schemaId,
    data: $data,
  }) {
    id
    data
    createdDateTime
    modifiedDateTime
  }
}`;

export const RETRIEVE_REDACTION_CODES = `
  query ($schemaId: ID!, $offset: Int, $limit: Int) {
    structuredDataObjects(schemaId: $schemaId, offset: $offset, limit: $limit) {
      count
      records {
        id
        createdDateTime
        modifiedDateTime
        data
      }
    }
  }
`;

export interface DeleteRedactionCodeQueryResponse {
  deleteStructuredData: {
    id: string;
  };
}
export const deleteRedactionCodeQuery = `
  mutation deleteRedactionCode($sdoId: ID!, $schemaId: ID!) {
    deleteStructuredData(input: {
      id: $sdoId,
      schemaId: $schemaId
    }) {
      id
    }
  }
`;

/**
 * `data` as well as `id`: a soft-deleted code still matches the filter — the
 * SDO filter has no notion of `isDeleted`, and filtering on it server-side
 * would miss every row written before the field existed — so the caller has
 * to read the flag back off each match and ignore the deleted ones
 * (VE-28768).
 */
export const checkRedactionCodeExistsQuery = `
  query($schemaId: ID!, $filter: JSONData) {
    structuredDataObjects(
      schemaId: $schemaId
      offset: 0
      limit: 10
      filter: $filter
    ) {
      count
      records {
        id
        data
      }
    }
  }
`;

export interface FetchCountRedactionCodeQueryResponse {
  structuredDataObjects: {
    count: number;
  };
}
export const fetchCountRedactionCodeQuery = `
  query ($schemaId: ID!, $offset: Int, $limit: Int) {
    structuredDataObjects(schemaId: $schemaId, offset: $offset, limit: $limit) {
      count
    }
  }
`;
